"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var components_1 = require("components");
var styles = __importStar(require("./Transcript.module.css"));
var Transcript = (function (_super) {
    __extends(Transcript, _super);
    function Transcript(props) {
        return _super.call(this, props) || this;
    }
    Transcript.prototype.render = function () {
        var _a = this.props, json_data = _a.json_data, onChange = _a.onChange, errors = _a.errors, _b = _a.transcript, title = _b.title, identifier = _b.identifier, address = _b.address, city = _b.city, attn = _b.attn, fax = _b.fax, className = _a.className;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("ul", { className: styles.sectionSubList },
                react_1.default.createElement("li", { className: styles.sectionListChild },
                    react_1.default.createElement(components_1.CheckBox, { id: identifier, json_data: json_data, onChange: onChange, className: className, errors: errors }),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("strong", null, title)),
                    react_1.default.createElement("p", null, address),
                    react_1.default.createElement("p", null, city),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("strong", null, "Attn:"),
                        " ",
                        attn),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("strong", null, "Fax Number:"),
                        " ",
                        fax)))));
    };
    return Transcript;
}(react_1.Component));
exports.default = Transcript;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHJhbnNjcmlwdC5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2Zvcm1zL2ludGVsbGl0ZWMvTnVyc2luZ0Vucm9sbG1lbnRQYWNrZXQvcGFydHMvU2VjdGlvbjcvVHJhbnNjcmlwdC9UcmFuc2NyaXB0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsNkNBQXNDO0FBRXRDLHlDQUFtQztBQUNuQyw4REFBaUQ7QUFVakQ7SUFBd0MsOEJBQW9CO0lBQ3hELG9CQUFZLEtBQUs7ZUFDYixrQkFBTSxLQUFLLENBQUM7SUFDaEIsQ0FBQztJQUVELDJCQUFNLEdBQU47UUFDVSxJQUFBLGVBTVEsRUFMVix3QkFBUyxFQUNULHNCQUFRLEVBQ1Isa0JBQU0sRUFDTixrQkFBeUQsRUFBNUMsZ0JBQUssRUFBRSwwQkFBVSxFQUFFLG9CQUFPLEVBQUUsY0FBSSxFQUFFLGNBQUksRUFBRSxZQUFHLEVBQ3hELHdCQUNVLENBQUE7UUFFZCxPQUFPLENBQ0gsOEJBQUMsZUFBSyxDQUFDLFFBQVE7WUFDWCxzQ0FBSSxTQUFTLEVBQUUsTUFBTSxDQUFDLGNBQWM7Z0JBQ2hDLHNDQUFJLFNBQVMsRUFBRSxNQUFNLENBQUMsZ0JBQWdCO29CQUNsQyw4QkFBQyxxQkFBUSxJQUNMLEVBQUUsRUFBRSxVQUFVLEVBQ2QsU0FBUyxFQUFFLFNBQVMsRUFDcEIsUUFBUSxFQUFFLFFBQVEsRUFDbEIsU0FBUyxFQUFFLFNBQVMsRUFDcEIsTUFBTSxFQUFFLE1BQU0sR0FDaEI7b0JBQ0Y7d0JBQ0ksOENBQVMsS0FBSyxDQUFVLENBQ3hCO29CQUNKLHlDQUFJLE9BQU8sQ0FBSztvQkFDaEIseUNBQUksSUFBSSxDQUFLO29CQUNiO3dCQUNJLHNEQUFzQjs7d0JBQUUsSUFBSSxDQUM1QjtvQkFDSjt3QkFDSSw0REFBNEI7O3dCQUFFLEdBQUcsQ0FDakMsQ0FDSCxDQUNKLENBQ1EsQ0FDcEIsQ0FBQTtJQUNMLENBQUM7SUFDTCxpQkFBQztBQUFELENBQUMsQUF6Q0QsQ0FBd0MsaUJBQVMsR0F5Q2hEIn0=